import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import styles from './SbSharedSearchCategoryTile.scss';

function SbSharedSearchCategoryTile({ imageUrl, url, category }) {
    return (
        <div className={styles.wrapper}>
            <img className={styles.img} src={imageUrl} alt={category} />
            <div className={styles.info}>
                <span className={styles.category}>{category}</span>
                <a href={url} className={styles.link}>
                    <FormattedMessage
                        id="SbSharedSearchCategoryTile.categoryLink"
                        defaultMessage="Shop"
                    />
                </a>
            </div>
        </div>
    );
}

SbSharedSearchCategoryTile.propTypes = {
    className: PropTypes.string,
    imageUrl: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
};

export { SbSharedSearchCategoryTile };
